import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';
import { formatFavoriteCount } from '../../tools/favorite-counter';

export const FavoriteMenu = {
    computed: {
        ...mapState(vplSiteStore, ['menu', 'favorite']),
        displayedFavoriteCount() {
            return formatFavoriteCount(this.favorite);
        }
    },
    template: `
        <template v-if="this.menu.favorite !== undefined">
            <a v-for="favoriteItem in this.menu.favorite.ITEMS" :href="favoriteItem.LINK" :class="{iseditable : this.menu.favorite.EDIT_BUTTON}" class="header__top-actions-link">
                <div class="header__top-actions-link-ico">
                    <svg class="icon icon-fav"><use xlink:href="#icon-fav"></use></svg>
                    <span v-if="displayedFavoriteCount" class="header__top-actions-link-amount" :class="{'is-overflow': displayedFavoriteCount === '99+'}">{{ displayedFavoriteCount }}</span>
                </div>

                <span>Избранное</span>

            </a>
             <div v-if="this.menu.favorite.EDIT_BUTTON" class="editablearea">
                <button :onclick="this.menu.favorite.EDIT_BUTTON">Редактировать пункты меню</button>
            </div>
        </template>
    `
}
